import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { PenTool } from 'lucide-react'
import { Card, CardContent } from '@/components/ui'

export function QuickWriteLauncher() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className="mb-8"
      data-tour="quick-write"
    >
      <Link to="/quick-write" className="block">
        <Card className="bg-gradient-to-br from-[var(--color-kids-primary)] to-[var(--color-kids-primary-dark)] text-white hover:shadow-lg transition-shadow">
          <CardContent className="p-6 sm:p-8 flex items-center gap-5">
            <div className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center flex-shrink-0">
              <PenTool className="w-7 h-7" />
            </div>
            <div className="flex-1 min-w-0">
              <h2 className="font-display text-2xl sm:text-3xl font-bold">Start writing</h2>
              <p className="text-sm sm:text-base opacity-85 mt-1">
                One prompt. Five minutes. No pressure.
              </p>
            </div>
            <span className="hidden sm:inline-block font-display text-2xl opacity-80">→</span>
          </CardContent>
        </Card>
      </Link>
    </motion.div>
  )
}
